<template>
  <div class="container">
    <a-breadcrumb separator=">">
      <a-breadcrumb-item href="" @click.native="() => $router.push('/')"
        >首页</a-breadcrumb-item
      >
      <a-breadcrumb-item>预约挂号</a-breadcrumb-item>
    </a-breadcrumb>

    <a-tabs>
      <a-tab-pane :key="item.key" :tab="item.name" v-for="item in tabs">
      </a-tab-pane>
    </a-tabs>

    <!--搜索框-->
    <!-- <a-space class="date-select" @click="jumpPage()">
      <a-input-search
        placeholder="搜索科室、医生"
        size="large"
        readOnly
        style="width: 100%"
        class="search-input"
    /></a-space> -->
    <!--搜索框-->

    <div class="select-box">
      <div class="select-hospital">
        <h3>选择校区</h3>
        <div
          class="hospital-item"
          v-for="(item, index) in hospitalList"
          :key="item.YINGYONGID"
          :class="[index == actived ? 'actived' : '']"
          @click="onChangeHospital(index, item)"
        >
          {{ item.YINGYONGMC }}
        </div>
      </div>

      <div class="select-department">
        <h3>一级科室</h3>

        <div class="loading-x">
          <a-spin v-if="depLoading" />
        </div>
        <div class="department-content">
          <div
            v-for="(item, index) in department"
            :key="index"
            :class="[
              index == activedDepartment ? 'activedDepartmentStyle' : '',
              'fontstyle',
            ]"
            @click="onChangeDepartment(index, item)"
          >
            {{ item.KESHIMC }}
          </div>
        </div>
      </div>

      <div class="select-department">
        <h3>二级科室</h3>
        <div class="loading-x">
          <a-spin v-if="depLoading" />
        </div>
        <div class="department-content">
          <div
            v-for="(item, index) in secondaryDepartment"
            :key="index"
            :class="[
              index == activedSDepartment ? 'activedDepartmentStyle' : '',
              'fontstyle',
            ]"
            @click="onChangeDepartment2(index, item)"
          >
            {{ item.KESHIMC }}
          </div>
        </div>
      </div>

      <div class="select-doctor">
        <h3>选择医生</h3>
        <div class="loading-x">
          <a-spin v-if="docLoading" />
        </div>
        <div class="department-content" v-if="doctorList.length > 0">
          <div>
            <div
              class="list-item"
              :key="index"
              v-for="(item, index) in doctorList"
              @click="onDoctorDetail(item)"
            >
              <img
                v-if="item.YISHENGXM != '普通' && item.YISHENGXM"
                src="@/assets/img/doc.png"
                alt=""
              />
              <img v-else src="@/assets/img/ptmz.png" alt="" />

              <div class="list-pro-name">
                <section class="item-name">
                  <span class="item-name-text">{{ item.YISHENGXM }}</span>
                  <span class="item-name-job" v-if="item.YISHENGZC">{{
                    item.YISHENGZC
                  }}</span>
                </section>
                <div class="item-department-name">
                  {{ item.KESHIMC }}
                </div>
                <div class="item-skilled" v-if="item.YISHENGJS">
                  {{ item.YISHENGJS }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <a-empty v-if="noDoc" />
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import base from "@/assets/base/base.js";
import {
  queryHosInfo,
  queryDoctorInfoV2,
  queryDepartmentInfoV2,
} from "@/api/registration";
export default {
  data() {
    return {
      searchKey: "",
      actived: 0,
      activedDepartment: 0,
      activedSDepartment: 0,
      tabs: [{ key: 1, name: "预约挂号" }],
      hospitalList: [
        {
          YINGYONGMC: "玉泉院区",
          YINGYONGID: "0101",
          address: "杭州市浙大路38号",
        },
        {
          YINGYONGMC: "紫金港院区",
          YINGYONGID: "0103",
          address: "杭州市余杭塘路866号",
        },
        {
          YINGYONGMC: "西溪院区",
          YINGYONGID: "0104",
          address: "杭州市天目山路148号",
        },
        {
          YINGYONGMC: "华家池院区",
          YINGYONGID: "0102",
          address: "杭州市凯旋路268号",
        },
      ],
      department: [], //一级科室
      secondaryDepartment: [], //二级科室
      doctorList: [],
      YINGYONGMC: "",
      YINGYONGID: "",
      remindList: [],
      noDoc: false,
      docLoading: false,
      depLoading: false,
    };
  },
  created() {
    this.YINGYONGMC =this.hospitalList[0].YINGYONGMC ;
    this.YINGYONGID = this.hospitalList[0].YINGYONGID ;
    this.dateList = base.getSevenYMD(new Date());
    this.getQueryDepartmentInfo(this.hospitalList[0]);
  },
  beforeDestroy() {
    this.$notification.destroy();
  },
  methods: {
    onImgError(i) {
      this.doctorList[i].headerImg = require("@/assets/img/doc.png");
    },

    // 查询挂号科室代码
    async getQueryDepartmentInfo(param) {
      this.department = [];
      this.secondaryDepartment = [];
      const params = {
        GUAHAOFS: "2", //挂号方式 1.挂号 2.预约
        GUAHAOLB: "", //挂号类别 1.普通 2.急诊 4.专家
        RIQI: this.dateList[0],
        JIESHURQ: this.dateList[this.dateList.length - 1],
        DUIWAIPB: "1", //1  过滤不开放互联网预约的科室
        YINGYONGMC: param.YINGYONGMC, //院区名称
        YINGYONGID: param.YINGYONGID, //院区id
      };
      this.depLoading = true;
      const { code, data } = await queryDepartmentInfoV2(params);
      this.depLoading = false;
      if (code == 200) {
        this.department = data || [];
        this.secondaryDepartment = data[0].child || [];
        if (this.secondaryDepartment.length > 0) {
          await this.getDoctor(this.secondaryDepartment[0]);
        } else {
          this.doctorList = [];
          this.noDoc = true;
        }
      }
    },
    //进入搜索页
    jumpPage() {
      this.$router.push({
        path: "/DDList",
      });
    },

    disabledDate(current) {
      // Can not select days before today and today
      return current && current < dayjs().endOf("day");
    },
    //查询科室医生
    async getDoctor(e) {
      this.noDoc = false;
      this.doctorList = [];
      let params = {
        GUAHAOFS: "2",
        GUAHAOLB: "", //1.普通 2.急诊 4.专家 空.全部
        KESHIDM: e.KESHIDM, //科室编号
        YINGYONGMC: this.YINGYONGMC, //院区名称
        YINGYONGID: this.YINGYONGID, //院区id
      };
      this.docLoading = true;
      const { code, data } = await queryDoctorInfoV2(params);
      this.docLoading = false;
      if (code == 200) {
        this.doctorList = data || [];
        if (this.doctorList.length <= 0) {
          this.noDoc = true;
        } else {
          this.noDoc = false;
        }
      } else {
        this.noDoc = true;
      }
    },
    onDoctorDetail(data) {
      sessionStorage.setItem("currentDoctorDetail", JSON.stringify(data));
      this.$router.push({
        path: "/doctorDetailV2",
        query: {
          KESHIDM: data.KESHIDM,
          YISHENGDM: data.YISHENGDM,
          YINGYONGMC: encodeURIComponent(this.YINGYONGMC),
          YINGYONGID: this.YINGYONGID,
        },
      });
    },
    async onChangeHospital(index, data) {
      this.activedDepartment = 0;
      this.actived = index;
      this.YINGYONGMC = data.YINGYONGMC;
      this.YINGYONGID = data.YINGYONGID;
      this.doctorList = [];
      await this.getQueryDepartmentInfo(data);
    },
    //一级科室选择
    onChangeDepartment(index, data) {
      this.activedDepartment = index;
      this.secondaryDepartment = data.child || [];
      this.activedSDepartment = 0;
      this.getDoctor(this.secondaryDepartment[0]);
    },
    //二级科室选择
    onChangeDepartment2(index, data) {
      this.activedSDepartment = index;
      this.getDoctor(data);
    },
  },
};
</script>

<style lang="scss" scoped>
.fontstyle {
  height: 50px;
  line-height: 50px;
  font-size: 16px;
  text-align: center;
  cursor: pointer;
}

.container {
  .date-select {
    padding: 20px;
    width: 100%;
    border-radius: 4px;
    background: #f8f8f8;
    .ant-space-item {
      width: 100%;
    }

    .date-label {
      font-size: 16px;
    }

    .date-select-day {
      cursor: pointer;
      background: #ffffff;
      padding: 10px;
      border: 1px solid #3f86ff;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #3f86ff;
    }

    .activedDay {
      color: #fff;
      background-color: #3f86ff;
    }
  }

  .select {
    .title {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      padding-right: 30px;

      h3 {
        font-size: 20px;
      }

      .line {
        width: 100px;
        height: 2px;
        background: #000;
      }
    }
  }

  .select-box {
    display: flex;
    justify-content: center;
    padding: 20px 0;

    h3 {
      height: 50px;
      line-height: 50px;
      text-align: center;
      background: #f8f8f8;
      font-size: 16px;
      font-weight: 400;
      color: #999999;
    }

    .select-hospital {
      flex: 1;
      border: 1px solid #f8f8f8;

      .hospital-item {
        cursor: pointer;
        height: 50px;
        box-sizing: border-box;
        font-size: 16px;
        text-align: center;
        line-height: 50px;
      }
    }

    .select-department {
      flex: 1;
      border: 1px solid #f8f8f8;
      padding: 0 16px;
    }

    .department-content {
      height: 500px;
      overflow-y: auto;
      overflow-x: hidden;
    }

    .select-doctor {
      flex: 1.5;
      cursor: pointer;
      box-sizing: border-box;
      font-size: 16px;
      border: 1px solid #f8f8f8;
      margin-left: -1px;

      .list-item {
        display: flex;
        padding: 16px;
        align-items: center;
        border-bottom: 1px solid #f8f8f8;
        cursor: pointer;

        img {
          text-align: center;
          width: 60px;
          height: 60px;
          margin-right: 12px;
          border-radius: 50%;
          border: 1px solid #f8f8f8;
        }

        .list-pro-name {
          margin-left: 12px;
          .item-name {
            margin: 2px 0;
          }

          .item-name {
            font-size: 14px;

            &-text {
              font-size: 18px;
              color: #333;
            }

            &-job {
              color: #333;
              padding: 0 10px;
            }

            &-tf {
              padding: 1px 4px;
              color: #3f86ff;
              border: 1px solid #3f86ff;
              border-radius: 2px;
              margin-right: 4px;
            }
          }

          .item-department-name {
            margin-top: 4px;
            color: #666;
            font-size: 14px;
          }

          .item-skilled {
            margin-top: 4px;
            width: 250px;
            font-size: 14px;
            color: #888;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }

  .actived,
  .activedDepartmentStyle {
    font-weight: bold;
    background-color: rgba(63, 134, 255, 0.07) !important;
  }
  .search-input {
    height: 40px;
    outline: none;
    cursor: pointer;
  }
}
.loading-x {
  text-align: center;
}
</style>
